import Tooltip from "@mui/material/Tooltip";
import { useTranslationApp } from "../../../../lib/i18next";
import { VALUE_NUMBER } from "../../../../i18n/keysTranslations";
import { ADS_CAMPAIGN_STATUS_DRAFT } from "../../../../utils/constants";
import { numberCompactFormat, numberDecimal } from "../../../../utils/numbers";

const formatMetricNumber = ({ value, applyFormat, t }) => {
  if (applyFormat) return numberCompactFormat(value);
  if (Number(value) % 1 !== 0) return Number(value).toFixed(2);
  return t(VALUE_NUMBER, { value });
};

const EntityMetricValue = ({
  statistics,
  type,
  status,
  applyFormat = true,
}) => {
  const { t } = useTranslationApp();
  const isDraft = status === ADS_CAMPAIGN_STATUS_DRAFT;

  if (isDraft || !statistics?.impressions) return "-";

  const currency = statistics.currency || "";
  const formatValue = (value) => formatMetricNumber({ value, applyFormat, t });

  switch (type) {
    case "mainAction":
      return Number(statistics.mainAction) > 0
        ? formatValue(statistics.mainAction)
        : "-";
    case "clicks":
      return statistics.click ? formatValue(statistics.click) : "-";
    case "ctr":
      return statistics.ctr ? `${formatValue(statistics.ctr)}%` : "-";
    case "impressions":
      return (
        <Tooltip title={statistics.impressions}>
          <span>
            {statistics.impressions ? formatValue(statistics.impressions) : "-"}
          </span>
        </Tooltip>
      );
    case "cpc":
      return statistics.cpc ? formatValue(statistics.cpc) : "-";
    case "cpm":
      return statistics.cpm ? formatValue(statistics.cpm) : "-";
    case "cpa":
      return statistics.costPerMainAction
        ? `${formatValue(statistics.costPerMainAction)} ${currency}`.trim()
        : "-";
    case "frequency":
      return statistics.frequency ? formatValue(statistics.frequency) : "-";
    case "spend":
      return `${formatValue(statistics.spend || 0)} ${currency}`.trim();
    case "roas":
      return Number(statistics.roas) > 0
        ? `${numberDecimal(Number(statistics.roas))}x`
        : "-";
    default: {
      const exhaustiveType = type;
      void exhaustiveType;
      return "-";
    }
  }
};

export default EntityMetricValue;
